import './payment-method-icon.scss';

import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { CreditCardEnum } from '@sola/schema/dotcom/checkout/billingInfo.ts';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';

const ccFallbackIconName = 'credit-card-02';

/**
 * Get icon component.
 */
export const getIconName = (paymentMethod: GraphQLSupporterPaymentMethod) => {
  if (paymentMethod.creditCard?.cardType) {
    return (
      {
        [CreditCardEnum.Amex]: 'card-amex',
        'american express': 'card-amex',
        [CreditCardEnum.Discover]: 'card-discover',
        [CreditCardEnum.Mastercard]: 'card-mastercard',
        'master card': 'card-mastercard',
        [CreditCardEnum.Visa]: 'card-visa',
      }[paymentMethod.creditCard.cardType.toLowerCase()] || ccFallbackIconName
    );
  }

  if (paymentMethod.ach) {
    return 'bank';
  }

  // What else?
  return '';
};

export interface PaymentMethodIconProps {
  paymentMethod: GraphQLSupporterPaymentMethod;
}

export const PaymentMethodIcon: React.FC<PaymentMethodIconProps> = ({
  paymentMethod,
}) => {
  const iconName = getIconName(paymentMethod);
  if (!iconName) {
    return null;
  }
  return (
    <ArkIcon
      className={cn('PaymentMethodIcon__icon', {
        'PaymentMethodIcon__icon-bank rounded-sm p-snug-xl':
          !!paymentMethod?.ach,
      })}
      /* Potentially fragile, but hard to dynamically check */
      iconName={iconName as IconNames}
    />
  );
};
